<template>
  <div>
          <el-form ref="form" :model="form" :rules="rules" label-width="250px">

            <!-- 第五步 -->
            <div>
              <el-form-item
                label="权利归属方式"
                prop="ownership"
              >
              <el-select
                  v-model="ownershipText"
                  @change="chooseOwnership"
                >
                  <el-option
                    v-for="(item, index) in constants.ownershipOpt"
                    :key="index"
                    :label="item.label"
                    :value="index"
                  >
                  </el-option>
                </el-select>
                <a-alert class="tips" type="warning" v-if="form.ownership == '1'">
                  <div slot="description" >
                    个人作品：自然人在没有他人的参与下，独立创作的作品。
                  </div>
                </a-alert>
                <a-alert class="tips" type="warning" v-if="form.ownership == '2'">
                  <div slot="description" >
                    合作作品：两人以上合作创作的作品。
                  </div>
                </a-alert>
                <a-alert class="tips" type="warning" v-if="form.ownership == '3'">      
                  <div slot="description" >
                    法人作品：由法人或者其他组织主持，代表法人或者其他组织意志创作，并由法人或者其他组织承担责任的作品，法人或者其他组织视为作者。
                  </div>
                </a-alert>
                <a-alert class="tips" type="warning" v-if="form.ownership == '4'">
                  <div slot="description" >
                    职务作品：公民为完成法人或者其他组织工作任务所创作的作品。
                  </div>
                </a-alert>
                <a-alert class="tips" type="warning" v-if="form.ownership == '5'">
                  <div slot="description" >
                    委托作品：委托人委托其他人创作的作品。
                  </div>
                  
                  
                </a-alert>
              </el-form-item>

              <el-form-item class="ownershipPicture1"
                label="权利归属证明材料"
                prop="ownershipPicture.additionalProp3"
                :rules="{ required: true, validator: valiIcon3, trigger: 'blur' }"
                v-if="form.ownership == '2' || form.ownership == '3' || form.ownership == '4' || form.ownership == '5'"
              >
              <div class="uploadBusinessLicense" >
                
                  <!-- <el-upload class="Uploader2 fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess3"
                    :before-upload="uploadBefore3" v-loading="loading3">
                      <img v-if="form.ownershipPicture.additionalProp3" :src="form.ownershipPicture.additionalProp3" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload> -->
                  <el-upload class="Uploader2 fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess3"
                    :before-upload="uploadBefore3" v-loading="loading3">
                    <el-input placeholder="请上传权利归属证明材料" v-model="imgSourceName3" disabled="disabled"></el-input>
                    <el-button type="primary">点击上传</el-button>
                  </el-upload>
                  <div class="clear"></div>
              </div>
                <a-alert class="tips" type="warning">
                  <div slot="message">温馨提示：</div>
                  <div slot="description" v-if="form.ownership == '2'">
                    <a
                      href="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql1.docx"
                      download="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql1.docx"
                      >合作作品权属协议书附件</a
                    >附件仅作参考，已有合同需明确著作权权属。
                  </div>
                  <div slot="description" v-if="form.ownership == '3'">
                    <a
                      href="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql2.docx"
                      download="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql2.docx"
                      >著作权权属申明附件</a
                    >附件仅作参考，已有合同需明确著作权权属。
                  </div>
                  <div slot="description" v-if="form.ownership == '4'">
                    <a
                      href="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql3.docx"
                      download="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql3.docx"
                      >职务作品权属约定附件</a
                    >附件仅作参考，已有合同需明确著作权权属。
                  </div>
                  <div slot="description" v-if="form.ownership == '5'">
                    <a
                      href="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql4.docx"
                      download="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql4.docx"
                      >委托创作协议书附件(甲方享有全部权利)</a
                    >,<a
                      href="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql5.docx"
                      download="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql5.docx"
                      >委托创作协议书附件(作者保留署名权)</a
                    >附件仅作参考，已有合同需明确著作权权属。
                  </div>
                </a-alert>
              </el-form-item>

              <div v-for="(item,index) in form.authors" :key="index">
                <el-form-item label="作者名称" :prop="'authors.'+index+'.name'" :rules="{ required: true, message: '请输入作者名称', trigger: 'blur' }">
                  <el-input placeholder="请输入作者名称" v-model="item.name"></el-input>
                </el-form-item>
                <el-form-item label="署名" :prop="'authors.'+index+'.signatureName'" class="signatureName" :rules="{ required: true, validator: valiIcon7, trigger: 'blur' }">
                    <el-select v-model="signatureTypeText[index]" @change="(val)=>chooseSignatureType(index,val)">
                      <el-option
                        v-for="(item, index) in constants.signatureType"
                        :key="index"
                        :label="item.label"
                        :value="index"
                      >
                      </el-option>
                    </el-select>
                  <el-input v-if="item.signatureType != '3'" v-model="item.signatureName"></el-input>
                </el-form-item>
                <el-form-item v-if="form.ownership == '2' || form.ownership == '4' || form.ownership == '5'" :class="index==0&&index+1 != form.authors.length?'btnBox_margin':''">
                  <el-button type="primary" v-if="index+1 == form.authors.length" @click="addAuthors(index)">添加作者</el-button>
                  <el-button type="primary" v-if="index != 0" @click="delAuthors(index)">删除作者</el-button>
                </el-form-item>
              </div>

              <el-form-item class="ownershipPicture5"
                label="受托人身份证明材料"
                prop="ownershipPicture.additionalProp6"
                :rules="{ required: true, validator: valiIcon6, trigger: 'blur' }"
                v-if="form.ownership == '5'"
              >
              <div class="uploadBusinessLicense" >
                  <!-- <el-upload class="Uploader5 fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess6"
                    :before-upload="uploadBefore6" v-loading="loading6">
                      <img v-if="form.ownershipPicture.additionalProp6" :src="form.ownershipPicture.additionalProp6" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload> -->
                  <el-upload class="Uploader5 fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess6"
                    :before-upload="uploadBefore6" v-loading="loading6">
                    <el-input placeholder="请上传受托人身份证明材料" v-model="imgSourceName6" disabled="disabled"></el-input>
                    <el-button type="primary">点击上传</el-button>
                  </el-upload>
                  <div class="clear"></div>
              </div>
                <a-alert class="tips" type="warning">
                  <div slot="message">温馨提示：</div>
                  <div slot="description">
                    请上传受托人的有效证件复印件，须亲笔签名或盖章确认
                  </div>
                </a-alert>
              </el-form-item>

              <el-form-item label="权利取得方式" prop="obtainType">
                <el-select
                  v-model="obtainTypeText"
                  placeholder="请选择权利取得方式"
                  @change="chooseObtainType"
                >
                  <el-option
                    v-for="(item, index) in constants.obtainType"
                    :key="index"
                    :label="item.label"
                    :value="index"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              
              <el-form-item
                label="权利取得方式证明材料"
                prop="ownershipPicture.additionalProp1"
                :rules="{ required: true, validator: valiIcon1, trigger: 'blur' }"
                v-if="form.obtainType == '2' || form.obtainType == '3' || form.obtainType == '4' || form.obtainType == '5'"
              >
              <div class="uploadBusinessLicense" >
                <!-- <el-upload class="Uploader2 fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess1"
								 :before-upload="uploadBefore1" v-loading="loading1">
									<img v-if="form.ownershipPicture.additionalProp1" :src="form.ownershipPicture.additionalProp1" class="avatar">
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload> -->
                <el-upload class="Uploader2 fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess1"
                  :before-upload="uploadBefore1" v-loading="loading1">
                  <el-input placeholder="请上传权利取得方式证明材料" v-model="imgSourceName1" disabled="disabled"></el-input>
                  <el-button type="primary">点击上传</el-button>
                </el-upload>
								<div class="clear"></div>
							</div>
                <a-alert class="tips" type="warning">
                  <div slot="message">温馨提示：</div>
                  <div slot="description">
                    <a
                      href="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql6.docx"
                      download="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql6.docx"
                      >权利取得方式证明材料附件</a
                    >点击下载后，加盖单位公章，法定代表人签字后拍照上传。
       
                  </div>
                </a-alert>
              </el-form-item>

              <el-form-item v-if="form.obtainType == '4'" label="其他权利获得方式说明" prop="obtainTypeDesc.text">
                <el-input
                  type="textarea"
                  :rows="6"
                  placeholder="请输入其他权利获得方式说明"
                  v-model="form.obtainTypeDesc.text"
                ></el-input>
              </el-form-item>
               
              <el-form-item label="权益拥有情况" prop="rightHave">
                <multiple-select
                  v-model="form.rightHave"
                  :listOpt="constants.right"
                  :worksType="form.worksType"
                ></multiple-select>
              </el-form-item>

              <el-form-item class="ownershipPicture5"
                label="代理委托书"
                prop="ownershipPicture.additionalProp5"
                :rules="{ required: true, validator: valiIcon5, trigger: 'blur' }"
                style="margin-bottom: 36px;"
              >
              <div class="uploadBusinessLicense" >
                  <!-- <el-upload class="Uploader5 fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess5"
                    :before-upload="uploadBefore5" v-loading="loading5">
                      <img v-if="form.ownershipPicture.additionalProp5" :src="form.ownershipPicture.additionalProp5" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload> -->
                  <el-upload class="Uploader5 fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess5"
                    :before-upload="uploadBefore5" v-loading="loading5">
                    <el-input placeholder="请上传代理委托书" v-model="imgSourceName5" disabled="disabled"></el-input>
                    <el-button type="primary">点击上传</el-button>
                  </el-upload>
                  <div class="clear"></div>
              </div>
              <a-alert class="tips" type="warning">
                  <div slot="message">温馨提示：</div>
                  <div slot="description">
                    请按照 <a
                      href="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql9.docx"
                      download="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql9.docx"
                      >代理委托书</a> 模版内容填写。
                  </div>
                </a-alert>
              </el-form-item>

              <el-form-item
                label="权利保证书"
                prop="ownershipPicture.additionalProp4"
                :rules="{ required: true, validator: valiIcon4, trigger: 'blur' }"
                style="margin-bottom: 36px;"
              >
              <div class="uploadBusinessLicense" >
                   <!-- <el-upload class="Uploader2 fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess4"
                        :before-upload="uploadBefore4" v-loading="loading4">
                          <img v-if="form.ownershipPicture.additionalProp4" :src="form.ownershipPicture.additionalProp4" class="avatar">
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload> -->
                      <!-- <el-checkbox v-model="ownershipChecked" @change="ownershipChange"></el-checkbox> 我已阅读并同意<a href="javascript:;" @click="openViewer">《作品登记权利保证书》</a>
                      <el-image-viewer
                        v-if="isOpenViewer"
                        :on-close="closeViewer"
                        :url-list="[require('../../../../assets/images/evidenceRight.png')]"
                      /> -->
                      <el-upload class="Uploader2 fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess4"
                        :before-upload="uploadBefore4" v-loading="loading4">
                        <el-input placeholder="请上传权利保证书" v-model="imgSourceName4" disabled="disabled"></el-input>
                        <el-button type="primary">点击上传</el-button>
                      </el-upload>
                      <div class="clear"></div>
                  </div>
                  <a-alert class="tips tipsFlag" type="warning" style="margin-top: 15px;">
                  <div slot="message">温馨提示：</div>
                  <div slot="description">
                    <a
                      href="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql7.docx"
                      download="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-ql7.docx"
                      >权利保证书模板</a
                    >请上传权利保证书(作品)，须亲笔签名或盖章确认。
                  </div>
                </a-alert>
              </el-form-item>

              <el-form-item
                label="其它证明材料"
                prop="ownershipPicture.additionalProp2"
              >
                <div class="uploadBusinessLicense" >
                  <!-- <el-upload class="Uploader3 fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess2"
                  :before-upload="uploadBefore2" v-loading="loading2">
                    <img v-if="form.ownershipPicture.additionalProp2" :src="form.ownershipPicture.additionalProp2" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload> -->
                  <el-upload class="Uploader3 fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess2"
                    :before-upload="uploadBefore2" v-loading="loading2" :element-loading-text="loadingText2">
                    <el-input placeholder="请上传其它证明材料" v-model="imgSourceName2" disabled="disabled"></el-input>
                    <el-button type="primary">点击上传</el-button>
                  </el-upload>
                  <el-button v-if="imgSourceName2" class="delete-btn" @click="handleDelete2"><i class="el-icon-delete"></i></el-button>
                  <div class="clear"></div>
                </div>
              </el-form-item>
              <!-- <el-form-item class="submitRow">
                <el-button type="primary" @click="onSubmit"
                  >提交版权登记</el-button
                >
              </el-form-item> -->
              <el-form-item prop="agreement" style="margin-bottom: 30px;">
                <el-checkbox-group v-model="agreement" >
                  <el-checkbox>我已阅读<span @click.stop="registerEquirements($event)">《登记须知》</span></el-checkbox>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item class="submitRow">
                <el-button type="primary" @click="prev">上一步</el-button>
                <el-button type="primary" @click="next">下一步</el-button>
              </el-form-item>
            </div>
          </el-form>

          <!-- 《登记须知》弹窗 -->
          <RegisterEquirements-Dialog ref="registerEquirementsDialog"></RegisterEquirements-Dialog>
  </div>
</template>

<script>
import { queryExistOrderItems } from "@/api/EvidenceService";
import { queryEvidenceRight } from "@/api/ObligeeService";
import multipleSelect from "../../../../components/form/multipleSelect";
import choosePersonDialog from "../../../../components/form/choosePersonDialog";
import resultView from "../components/resultView";
import ChinaAreaData from "@/components/ChinaAreaData";
import { mapGetters } from "vuex";
import { mixinsScrollErrorPosition } from "../../../../mixins";
import constants from "@/utils/constants";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import RegisterEquirementsDialog from "../../../../components/RegisterEquirementsDialog"
import request from '@/utils/request'

export default {
  name: "RegisterInputForm",
  mixins: [mixinsScrollErrorPosition],
  components: {
    multipleSelect,
    choosePersonDialog,
    resultView,
    ChinaAreaData,
    ElImageViewer,
    RegisterEquirementsDialog
  },
  props: {
    stepForm: Object,
  },
  data() {
    return {
      uploadUrl:`${process.env.VUE_APP_BASEURL}/v1/ins/file/upload?path=register/evidence/files/`,
      uploadHeaders:{ 
        'Authorization': this.$store.getters.token,
        'Product-Mode': "READ",
        'Terminal-Code': "IPCHAIN2"+ this.$store.getters.terminalCode,
        'Terminal-Type': "WEB",
        'Merchant-Id': "5"
      },
      constants,
      ownershipText: "",
      signatureTypeText: [],
      obtainTypeText: "",

      // form: {
      //   ownership: "1",
      //   obtainType: "",
      //   authors: [
      //     {name:"",signatureType:"1",signatureName:"",orders:1},
      //   ],
      //   obtainTypeDesc: {
      //     text:"",
      //   },
      //   ownershipPicture: {
      //     "additionalProp1": "",
      //     "additionalProp2": "",
      //     "additionalProp3": "",
      //     "additionalProp4": "",
            // "additionalProp5": "",
            // "additionalProp6": "",
      //   },
      //   rightHave: [],

      // },
      form: this.stepForm,
      ownershipChecked: false,
      isOpenViewer: false,
      rules: {
        ownership: [
          { required: true, message: "请选择权利权属", trigger: "blur" },
        ],
        obtainType: [
          { required: true, message: "请选择权利取得方式", trigger: "blur" },
        ],
        rightHave: [
          { required: true, message: "请选择权益拥有情况", trigger: "blur" },
        ],

        agreement: [
          { required: true, validator: this.valiAgreement, trigger: "change" },
        ],

      },
      isAuthorDialogVisible: false,
      isRightDialogVisible: false,

      lastform: {
        type: Object,
      },

      imgSourceName1: '',
      imgSourceName2: '',
      imgSourceName3: '',
      imgSourceName4: '',
      imgSourceName5: '',
      imgSourceName6: '',

      loading1: false,
      loading2: false,
      uploadControllers2: {},  // 其它证明材料的分片上传控制器
      loadingText2: '加载中...',  // 其它证明材料分片上传进度文字
      loading3: false,
      loading4: false,
      loading5: false,
      loading6: false,

      agreement: true, // << 登记须知 >> 默认勾选
      
    };
  },
  mounted() {
    window.addEventListener("beforeunload", this.beforeUnloadHandler, false)
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.beforeUnloadHandler, false)
    // 中断所有分片上传
    Object.keys(this.uploadControllers2).forEach(uid => {
      this.uploadControllers2[uid].abort();
    });
    this.uploadControllers2 = {};
  },
  methods: {
    beforeUnloadHandler(e) {
      e.returnValue = "离开此页面？" // 此处返回任意字符串，不返回null即可，不能修改默认提示内容
    },
  },
  computed: {
    ...mapGetters(["mid", "userInfo", "evidencePaymentPrice", "vipInfo","obligeeList"]),
  },
  created() {
    // 从 localStorage 中加载数据
    const savedData = localStorage.getItem(`form01_${this.mid}`);
    if (savedData) {
      this.form = JSON.parse(savedData);
      this.imgSourceName1 = this.form.ownershipPicture.additionalProp1.split('/').pop();
      this.imgSourceName2 = this.form.ownershipPicture.additionalProp2.split('/').pop();
      this.imgSourceName3 = this.form.ownershipPicture.additionalProp3.split('/').pop();
      this.imgSourceName4 = this.form.ownershipPicture.additionalProp4.split('/').pop();
      this.imgSourceName5 = this.form.ownershipPicture.additionalProp5.split('/').pop();
      this.imgSourceName6 = this.form.ownershipPicture.additionalProp6.split('/').pop();
    }
    
    this.loadData();
    // this.form = this.stepForm
    if(this.form.ownership){
      this.ownershipText = this.constants.ownershipOpt[this.form.ownership * 1 - 1].label;
    }else{
      this.form.ownership = '1';
      this.ownershipText = '个人作品';
    }
    if(this.form.authors[0].name){
      let arr = [];
      for(let i =0; i<this.form.authors.length; i++){
        arr.push(this.constants.signatureType[this.form.authors[i].signatureType * 1 -1].label)
      }
      this.signatureTypeText = arr;
    }
    if(this.form.obtainType){
      this.obtainTypeText = this.constants.obtainType[this.form.obtainType * 1 - 1].label;
    }else{
      this.form.obtainType = '1';
      this.obtainTypeText = '原始';
    }
  },
  watch: {
    form: {
      handler(newValue) {
        // 自动保存表单数据到 localStorage
        localStorage.setItem(`form01_${this.mid}`, JSON.stringify(newValue));
      },
      deep: true
    },
  },
  methods: {
    loadData() {
      queryExistOrderItems().then(({ data }) => {
        this.fileList = data;
      });
      if(this.obligeeList){
        this.obligees = this.obligeeList;
      }else{
        this.$message.error("获取著作权人列表失败")
        // 如果数据还未加载完成，可以设置监听或延迟检查
        const timer = setInterval(() => {
            if (this.obligeeList) {
                this.obligees = this.obligeeList;
                clearInterval(timer);
            }
        }, 100);
      }
    },
    onSetAuthorDialogClose() {
      this.isAuthorDialogVisible = false;
    },
    onSetRightDialogClose() {
      this.isRightDialogVisible = false;
    },
    onChooseAuthor(users) {
      this.form.author = users;
    },
    onChooseRight(users) {
      this.form.right = users;
    },
    valiIcon1(rule, value, callback){
					if (!this.form.ownershipPicture.additionalProp1) {
					  callback(new Error('请上传权利取得方式证明材料'));
					  return; 
					}
					callback();
		},
    valiIcon3(rule, value, callback){
					if (!this.form.ownershipPicture.additionalProp3) {
					  callback(new Error('请上传权利归属证明材料'));
					  return; 
					}
					callback();
		},
    valiIcon4(rule, value, callback){
					if (!this.form.ownershipPicture.additionalProp4) {
					  callback(new Error('请上传权利保证书'));
					  return;
					}
					callback();
		},
    // valiIcon4(rule, value, callback){
		// 			if (!this.ownershipChecked) {
		// 			  callback(new Error('请勾选权利保证书'));
		// 			  return;
		// 			}
		// 			callback();
		// },
    valiIcon5(rule, value, callback){
					if (!this.form.ownershipPicture.additionalProp5) {
					  callback(new Error('请上传代理委托书'));
					  return; 
					}
					callback();
		},
    valiIcon6(rule, value, callback){
					if (!this.form.ownershipPicture.additionalProp6) {
					  callback(new Error('请上传受托人身份证明材料'));
					  return; 
					}
					callback();
		},
    valiIcon7(rule, value, callback){
          if (this.form.authors[0].signatureName == '') {
					  callback(new Error('请输入署名'));
					  return;
					}
					// if (this.signatureTypeText[0] == '本名' && this.form.authors[0].name != this.form.authors[0].signatureName) {
					//   callback(new Error('作者名称和本名不一致'));
					//   return;
					// }
					callback();
		},
    valiCity(rule, value, callback) {
      if (!this.form.province) {
        callback(new Error("请选择省份"));
        return;
      }
      if (!this.form.city) {
        callback(new Error("请选择城市"));
        return;
      }
      if (!this.form.area) {
        callback(new Error("请选择区县"));
        return;
      }
      callback();
    },

    uploadSuccess1(res, file) {
      this.imgSourceName1 = res.sourceName + '.' + res.fileType;
      this.form.ownershipPicture.additionalProp1 = res.downloadUrl;
      this.loading1 = false;
      this.$refs.form.validateField('ownershipPicture.additionalProp1');
    },
    uploadBefore1(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'; 
      const isLt2M = file.size / 1024 / 1024 < 5;
      this.loading1 = true;
      if (!isImage) {
        this.$message.error('上传图片只能是 JPG、JPEG、PNG 格式!');
        this.loading1 = false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        this.loading1 = false;
      }
      return isImage && isLt2M;
    },
    uploadSuccess2(res, file) {
      this.imgSourceName2 = res.sourceName + '.' + res.fileType;
      this.form.ownershipPicture.additionalProp2 = res.downloadUrl;
      this.loading2 = false;
      this.$refs.form.validateField('ownershipPicture.additionalProp2');
    },
    uploadBefore2(file) {
      const allowedTypes = ['.jpg','.jpeg','.gif','.bmp','.png','.doc','.docx','.xls','.xlsx','.ppt','.pptx','.pdf','.txt','.wav','.mp4','.wmv','.mp3','.psd'];
        // 检查文件格式
        const ext = '.' + file.name.split('.').pop().toLowerCase();
        if (!allowedTypes.includes(ext)) {
            this.$message.error('不支持的文件格式：' + ext);
            return false;
        }
        // 检查文件大小
        if (file.size > 100 * 1024 * 1024) {
            this.$message.error('文件大小不能超过100MB');
            return false;
        }
        // 大于10MB使用分片上传
        if (file.size > 10 * 1024 * 1024) {
          this.loading2 = true;
          setTimeout(() => this.chunkUpload2(file), 0);
          return false;
        }
        this.loading2 = true;
        // 小文件：继续普通上传
        return true;
    },
    handleDelete2(){
      // 中断可能正在进行的分片上传
      Object.keys(this.uploadControllers2).forEach(uid => {
        this.uploadControllers2[uid].abort();
      });
      this.uploadControllers2 = {};

      this.imgSourceName2 = '';
      this.form.ownershipPicture.additionalProp2 = '';
      this.loading2 = false;
      this.$refs.form.validateField('ownershipPicture.additionalProp2');
    },
    // ===== 其它证明材料 分片上传 =====
    async chunkUpload2(file) {
      const controller = new AbortController();
      this.uploadControllers2[file.uid] = controller;
      if (controller.signal.aborted) throw new Error('上传已被中断');

      try {
        this.loading2 = true;
        this.loadingText2 = '正在获取上传ID...';

        // 1. 获取上传ID
        const fd1 = new FormData();
        fd1.append('fileName', file.name);
        const randomPath = Math.random().toString(36).substring(2, 9);
        const idRes = await fetch(
          `${process.env.VUE_APP_BASEURL}/v1/ins/file/uploadId?path=register/evidence/files/${randomPath}`,
          { method: 'POST', body: fd1, headers: this.uploadHeaders }
        );
        if (!idRes.ok) throw new Error('获取上传ID失败');
        const uploadId = (await idRes.json()).uploadId;

        // 2. 分片上传
        const chunkSize = 5 * 1024 * 1024;
        const totalChunks = Math.ceil(file.size / chunkSize);
        const partETags = [];

        this.loadingText2 = `分片上传中... 0/${totalChunks}`;

        for (let i = 0; i < totalChunks; i++) {
          if (controller.signal.aborted) throw new Error('上传已被中断');
          const start = i * chunkSize;
          const chunk = file.slice(start, Math.min(start + chunkSize, file.size));

          this.loadingText2 = `分片上传中... ${i}/${totalChunks}`;
          this.imgSourceName2 = `${file.name} （分片上传进度：${i}/${totalChunks})`;

          const fd2 = new FormData();
          fd2.append('currentPartNumber', i + 1);
          fd2.append('currentPartSize', chunk.size);
          fd2.append('partNum', totalChunks);
          fd2.append('offset', start);
          fd2.append('file', chunk);

          const res = await fetch(
            `${process.env.VUE_APP_BASEURL}/v1/ins/file/uploadPart/${uploadId}?path=register/evidence/files/${randomPath}`,
            { method: 'POST', body: fd2, headers: this.uploadHeaders }
          );
          if (!res.ok) throw new Error(`分片 ${i + 1} 上传失败`);

          const part = await res.json();
          if (part.eTag) partETags.push({ partNumber: i + 1, eTag: part.eTag });

          this.loadingText2 = `分片上传中... ${i + 1}/${totalChunks}`;
          this.imgSourceName2 = `${file.name} （分片上传进度：${i + 1}/${totalChunks})`;
        }

        if (controller.signal.aborted) throw new Error('上传已被中断');

        // 3. 合并分片
        this.loadingText2 = '正在合并分片...';
        const mergeRes = await request('POST', '/v1', `/ins/file/merge/${uploadId}`, partETags);

        this.uploadSuccess2(mergeRes.data, file);
        this.loadingText2 = '加载中...';
        delete this.uploadControllers2[file.uid];
      } catch (e) {
        this.$message.error('分片上传失败');
        this.imgSourceName2 = '';
        this.loading2 = false;
        this.loadingText2 = '加载中...';
        this.form.ownershipPicture.additionalProp2 = '';
        delete this.uploadControllers2[file.uid];
      }
    },
    // 中断其它证明材料上传
    abortUpload2(file) {
      const uid = file && (file.uid || file.rawFile?.uid);
      if (uid && this.uploadControllers2[uid]) {
        this.uploadControllers2[uid].abort();
        delete this.uploadControllers2[uid];
        return true;
      }
      return false;
    },

    uploadSuccess3(res, file) {
      this.imgSourceName3 = res.sourceName + '.' + res.fileType;
      this.form.ownershipPicture.additionalProp3 = res.downloadUrl;
      this.loading3 = false;
      this.$refs.form.validateField('ownershipPicture.additionalProp3');
    },
    uploadBefore3(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'; 
      const isLt2M = file.size / 1024 / 1024 < 5;
      this.loading3 = true;
      if (!isImage) {
        this.$message.error('上传图片只能是 JPG、JPEG、PNG 格式!');
        this.loading3 = false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        this.loading3 = false;
      }
      return isImage && isLt2M;
    },
    uploadSuccess4(res, file) {
      this.imgSourceName4 = res.sourceName + '.' + res.fileType;
      this.form.ownershipPicture.additionalProp4 = res.downloadUrl;
      this.loading4 = false;
      this.$refs.form.validateField('ownershipPicture.additionalProp4');
    },
    uploadBefore4(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'; 
      const isLt2M = file.size / 1024 / 1024 < 5;
      this.loading4 = true;
      if (!isImage) {
        this.$message.error('上传图片只能是 JPG、JPEG、PNG 格式!');
        this.loading4 = false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        this.loading4 = false;
      }
      return isImage && isLt2M;
    },
    uploadSuccess5(res, file) {
      this.imgSourceName5 = res.sourceName + '.' + res.fileType;
      this.form.ownershipPicture.additionalProp5 = res.downloadUrl;
      this.loading5 = false;
      // 清除上传状态
      this.$refs.form.validateField('ownershipPicture.additionalProp5');
    },
    uploadBefore5(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'; 
      const isLt2M = file.size / 1024 / 1024 < 5;
      this.loading5 = true;
      if (!isImage) {
        this.$message.error('上传图片只能是 JPG、JPEG、PNG 格式!');
        this.loading5 = false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        this.loading5 = false;
      }
      
      return isImage && isLt2M;
    },
    uploadSuccess6(res, file) {
      this.imgSourceName6 = res.sourceName + '.' + res.fileType;
      this.form.ownershipPicture.additionalProp6 = res.downloadUrl;
      this.loading6 = false;
      this.$refs.form.validateField('ownershipPicture.additionalProp6');
    },
    uploadBefore6(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'; 
      const isLt2M = file.size / 1024 / 1024 < 5;
      this.loading6 = true;
      if (!isImage) {
        this.$message.error('上传图片只能是 JPG、JPEG、PNG 格式!');
        this.loading6 = false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        this.loading6 = false;
      }
      
      return isImage && isLt2M;
    },
    
    
    chooseOwnership(index){
      // console.log("选择权利归属");
      this.ownershipText = this.constants.ownership[index].label;
      this.form.ownership = this.constants.ownership[index].value;
      if(this.form.ownership == '2'){
        this.form.authors.push({"name":"","signatureType":"0","signatureName":"","orders": 2})
      }else{
        this.form.authors.splice(1,1)
      }
    },
    chooseSignatureType(index,typeIndex) {
      // console.log("选择权署名");
      // console.log("index",index);
      // console.log("typeIndex",typeIndex);
      if(typeIndex == 0 && this.form.authors[index].name != ''){
        this.form.authors[index].signatureName = this.form.authors[index].name;
      }else{
        this.form.authors[index].signatureName = '';
      }
      this.signatureTypeText[typeIndex] = this.constants.signatureType[typeIndex].label
      this.$set(this.form.authors, index, {
          ...this.form.authors[index],
          signatureType: this.constants.signatureType[typeIndex].value,
      })
      
    },
    chooseObtainType(index){
      // console.log("选择权利取得方式 ");
      this.obtainTypeText = this.constants.obtainType[index].label;
      this.form.obtainType = this.constants.obtainType[index].value;
    },

    addAuthors(index){
      this.form.authors.push({"name":"","signatureType":"0","signatureName":"","orders":index+2})
      this.signatureTypeText[index+1] = ''
      // console.log("作者：",this.form.authors);
    },
    delAuthors(index){
      this.form.authors.splice(index,1)
    },

    // 勾选权利保证书，生成保证书图片
    ownershipChange(){
      if(this.ownershipChecked == true){
        let signature = '';
        for(let i in this.form.right){
          if(this.form.right[i].obligeeType == '1'){
            //  个人著作权人
            signature += this.form.right[i].userName + ","
          }else{
            // 企业著作权人
            signature += this.form.right[i].companyName + ","
          }
        }
        this.signature = signature.substring(0, signature.lastIndexOf(','));
        // console.log(this.signature);
        let param = {
          "signature": this.signature,
          "subject": this.form.subject,
        }
        queryEvidenceRight(param).then(({ data }) => {
          this.form.supportCode = data.supportCode;
          this.form.ownershipPicture.additionalProp4 = data.supportInfo.jpgUrl;
          this.ownershipCheckedStatus = true;
        });
      }
    },
    // 查看快照
    openViewer() {
      this.isOpenViewer = true
    },
    // 关闭图片预览
    closeViewer() {
      this.isOpenViewer = false
    },

    // 自定义验证同意协议
    valiAgreement(rule, value, callback){
      if (!this.agreement) {
        callback(new Error("请勾选同意协议"));
        return;
      }
      callback();
    },
    registerEquirements(event){
      // 点击打开登记须知弹窗，阻止切换勾选框冒泡
      event.stopPropagation();
      event.preventDefault();
      // console.log("打开登记须知");
      this.$refs.registerEquirementsDialog.showDialog();

    },


    prev(){
        this.$emit('getnext',4)
    },
    async next(){
      // localStorage.removeItem(`form01_${this.mid}`); // 测试清理form缓存
        try {
          // if (!this.ownershipCheckedStatus) {
					//   this.$message({
          //     type: 'warning',
          //     message: '请稍等,正在生成权利保证书！'
          //   });
					//   return;
					// }
          const formBaseResult = await this.$refs["form"].validate();
        } catch (error) {
          // 有错误,定位到错误
          // eslint-disable-next-line
          console.error(error);
          this.mixinsScrollView();
          return;
        }
        console.log('this.form.ownership66666666666',this.form.ownership);
        console.log('this.form.ownershipPicture55555555555',this.form.ownershipPicture);
        // 添加验证：如果权利取得方式是"原始"，清空权利取得方式证明材料
        if (this.form.obtainType == '1') {
          this.form.ownershipPicture.additionalProp1 = '';
        }
        // 添加验证：如果权利取得方式不是"其他"，清空其他权利获得方式说明
        if (this.form.obtainType != '4') {
          this.form.obtainTypeDesc.text = '';
        }

        // 清空遗留的证书图片信息
        if(this.form.ownership == '1'){ //清空权利归属证明材料
          this.form.ownershipPicture.additionalProp3 = '';
          this.form.ownershipPicture.additionalProp6 = '';
        }else if(this.form.ownership != '3'){ //清空代理委托书
          // this.form.ownershipPicture.additionalProp5 = '';
        }else if(this.form.ownership != '5'){ // 清空受托人身份证明材料
          this.form.ownershipPicture.additionalProp6 = '';
        }
        if(this.form.obtainType == '1'){
          this.form.ownershipPicture.additionalProp1 = '';
        }

        // console.log("lastform:",this.lastform);
        console.log(this.form);
        this.$emit('getnext',6,this.form)
    },

  },
};
</script>

<style lang='scss' scoped>
@import "../../../../assets/css/inputForm.scss";
.commonWhiteBg {
  min-height: 800px;
  /deep/ .ant-popover-arrow {
    left: 30%;
  }
}
.ownershipRow {
  margin-bottom: 0;
}
.ownershipWrap {
  position: relative;
  padding-top: 40px;
  /deep/ .el-radio-group {
    position: absolute;
    width: 200%;
    left: 0;
    top: 11px;
  }
  .tips {
    margin-top: 0;
    .red {
      color: #ff4d4f;
      vertical-align: middle;
    }
  }
}
// .tips {
//   margin-top: 20px;
// }
.tips {
  // position: initial;
  position: absolute;
    width: 384px;
    right: -410px;
    top: 0;
    a{
      color: #007dff;
      border-bottom: 1px solid #007dff;
    }
}
.signatureName {
  .el-select,
  .el-input {
    width: calc(110% / 2.4)!important;
  }
  .el-select {
    margin-right: calc(20% / 2.4)!important;
  }
}
.Uploader2,.Uploader3,.Uploader4,.Uploader5 {
  font-size: 14px;
  // width: 132px;
  // height: 180px;
  text-align: center;
  background: #f9fafc;
  border-radius: 4px;
  border: 1px solid #c0ccda;
  position: relative;
  .avatar-uploader-icon{
    font-size: 28px;
    color: #8c939d;
    text-align: center;
    line-height: 178px;
  }
  .el-upload{
    width: 100%;
    position: relative;
  }
  .el-input{
    width: calc(100% - 100px);
    position: absolute;
    left: 0;
    top: 0;
  }
  button{
    width: 100px;
    position: absolute;
    right: 0;
    top: 0;
  }
}
.Uploader2 img,.Uploader3 img,.Uploader4 img,.Uploader5 img{
  width: auto;
	max-width: 100%;
  height: auto;
  max-height: 100%;
  position: absolute;
  top:50%; 
  left:50%;
  transform: translate(-50%,-50%);
}
/deep/ .submitRow .el-form-item__content {
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.MainStepsForm .submitRow button {
  width: 46% !important;
}

.stepTitle{
  width: 100%;
  margin: 50px 0 100px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.stepTitle li {
  padding: 0 10px;
}
.stepTitle li span{
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
  text-align: center;
  border: 1px solid rgba(0, 18, 22, 0.2);
  font-size: 16px;
  color: rgba(0, 18, 22, 0.2);

}
.stepTitle li p{
  color: rgba(0, 18, 22, 0.45);
  display: inline-block;
  margin-left: 10px;
  font-size: 16px;
}
.stepTitle li.active span{
  border-color: #007DFF;
  color: #fff;
  background: #007DFF;
}
.stepTitle li.active p{
  color: #007DFF;
}
.ownershipPicture1 .tips{
  top: 45px;
}
.btnBox_margin{
  margin-bottom: 0px!important;
}

/deep/{
  .el-radio__label,.el-checkbox__label{color: rgba(0,0,0,0.65)!important;}
  .el-checkbox__label span{color: #007DFF;}
}
/deep/.el-checkbox-group{line-height: 20px;}
/deep/.el-checkbox{white-space: inherit;display: flex;align-items: center;}

.uploadBusinessLicense{position: relative;}
.uploadBusinessLicense .delete-btn{position: absolute;right: 110px;top: 9px;width: 25px;height: 25px;padding: 0;margin: 0;border-radius: 50%;border: 1px solid #FFF;background: #007DFF;}
.uploadBusinessLicense .delete-btn i{color: #FFF;}

/* 让 loading 文字显示在圈圈右侧 */
/deep/ .el-loading-spinner {
  display: flex !important;
  align-items: center;
  justify-content: center;
  margin-top: 0 !important;
  top: 50%;
  transform: translateY(-50%);
}

/deep/ .el-loading-spinner .circular {
  margin-right: 10px;
}

/* 覆盖默认的 margin-top: 5px（原本是给下方文字留的间距） */
/deep/ .el-loading-spinner .el-loading-text {
  margin: 0 !important;
  color: #409EFF;       /* 可选：和圈圈同色，更像一体 */
  font-size: 14px;
}

// 适配移动端
@media screen and (max-width: 991px){
  /deep/ .el-form-item__content{margin-left: 0!important;display: inline-block;width: 100%;}
  /deep/ .el-form-item__label{width: auto!important;}
  .tips{position: inherit;width: 100%;margin-top: 10px;right: 0!important;top: 0!important;}
  .flexBox{display: block!important;}
  .tipsFlag{margin-top: 0!important;}
}

</style>
